import React from "react";
import { useUserDataContext } from "@/contexts/UserContext";
import cls from "@/components/Chat/styles.module.scss";
import Typography from "@/ui/Typography/Typography";
import { useTranslation } from "react-i18next";
import Chat from "./Chat";
import type { ChatProps } from "./Chat";

const ChatContainer: React.FC<ChatProps> = (props) => {
  const { t } = useTranslation();
  const { userData } = useUserDataContext();

  if (userData?.is_chat_banned)
    return (
      <Typography
        size="4xl"
        family="Manrope"
        weight="bold"
        color="var(--text-brown)"
        className={cls.banned}
      >
        {t("chat.bannedInChat")}
      </Typography>
    );
  return <Chat {...props} />;
};

export default ChatContainer;
